import Cookies from "js-cookie";
import snakeToCamelCase from "./snakeToCamelCase";

export const getMixPanelParams = () => {
  try {
    const allCookies = Cookies.get();
    const mixpanelKey = Object.keys(allCookies).filter(
      (key) => key.startsWith("mp_") && key.endsWith("_mixpanel")
    );

    if (!mixpanelKey || mixpanelKey?.length === 0) {
      return null;
    }

    if (mixpanelKey.length > 1) {
      console.error("More than one mixpanel cookie key");
    }

    const decodedValue = decodeURIComponent(allCookies[mixpanelKey[0]]);
    const parsedData = JSON.parse(decodedValue);

    const allPropsThatStartsWithUtm = Object.fromEntries(
      Object.entries(parsedData).filter(([key]) => key.startsWith("utm"))
    );
    return snakeToCamelCase(allPropsThatStartsWithUtm);
  } catch (err) {
    console.error("Fatal error on getMixPanelParams", err);
  }

  return null;
};
